import { PersonAdd } from '@mui/icons-material'
import { CriteriaPanel } from '../criteria'
import { useAdventureEditorStore } from '../../../stores/adventureEditorStore'

export function JoinCriteriaPanel() {
  const adventureId = useAdventureEditorStore((state) => state.adventureId)

  return (
    <CriteriaPanel
      type="join"
      title="Join Criteria"
      description="Control who can join this adventure based on conditions"
      icon={<PersonAdd />}
      adventureId={adventureId}
    />
  )
}
